module.exports = __webpack_public_path__ + "static/media/user-management.b450df94.png";